// app/javascript/controllers/mask_controller.js
// Usage: <%= f.text_field :property_apn, data: { controller: "mask", mask_pattern_value: "apn", action: "input->mask#applyMask" } %>
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { pattern: String };

  connect() {
    this.patterns = {
      phone: "000-000-0000",
      apn: "000-000-000-000",
      account: "00-00",
      zip: "00000",
    };

    // Apply initial mask if field has value
    if (this.element.value) {
      this.applyMask();
    }
  }

  applyMask() {
    const pattern = this.patterns[this.patternValue];
    if (!pattern) return;

    const cursorPos = this.element.selectionStart;
    const oldValue = this.element.value;
    const cleaned = oldValue.replace(/\D/g, "");

    // Format value according to pattern
    let formatted = "";
    let digitIndex = 0;

    for (let i = 0; i < pattern.length; i++) {
      const patternChar = pattern[i];

      if (patternChar === "0") {
        if (digitIndex >= cleaned.length) break;
        formatted += cleaned[digitIndex++];
        continue;
      }

      // Allow the separator as soon as at least one digit is present so users
      // can type either "0000" (we insert the dash) or "00-00" themselves.
      if (digitIndex > 0 && digitIndex < cleaned.length) {
        formatted += patternChar;
      }
    }

    // Update value
    this.element.value = formatted;

    // Calculate cursor position preserving relative placement to digits and separators
    const digitsBeforeCursor = oldValue
      .slice(0, cursorPos)
      .replace(/\D/g, "").length;
    const separatorsBeforeCursor = (
      oldValue.slice(0, cursorPos).match(/\D/g) || []
    ).length;

    let newPos = formatted.length;
    let digitsSeen = 0;
    let separatorsSeen = 0;

    for (let i = 0; i < formatted.length; i++) {
      if (/\d/.test(formatted[i])) {
        digitsSeen++;
      } else {
        separatorsSeen++;
      }

      if (
        digitsSeen > digitsBeforeCursor ||
        (digitsSeen === digitsBeforeCursor &&
          separatorsSeen >= separatorsBeforeCursor)
      ) {
        newPos = i + 1;
        break;
      }
    }

    this.element.setSelectionRange(newPos, newPos);
  }
}
